import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import store from '@/store/store'
const https = axios.create({
    baseURL: process.env.VUE_APP_API,
    timeout: 120000,
})

// 请求拦截器
https.interceptors.request.use(function (config) {
    // config.headers['token'] = Vue.cookie.get('token')
    if(!config.isToken && store.state.token){
        if(config.method == 'post'){
            config.data = {...config.data,token:store.state.token}
        }else{
            config.params = {...config.params,token:store.state.token}
        }
    }
    if (config.method == 'post') {
        if(config.contentType == 'json'){
            config.headers['Content-Type'] = 'application/json';
        }else{
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'
            config.data = qs.stringify(config.data || config.params)
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
// 响应拦截器
https.interceptors.response.use(function (response) {
    if (response.status == '200') {
        response = response.data;
    }
    return response;
}, function (error) {
    if (error && error.response) {
        switch (error.response.status) {
            case 400:
                error.message = '错误请求'
                console.log('错误请求')
                break;
            case 401:
                error.message = '未授权或者登录信息已过期，请重新登录'
                console.log('未授权，请重新登录')
                break;
            case 403:
                error.message = '拒绝访问'
                console.log('拒绝访问')
                break;
            case 404:
                error.message = '请求错误,未找到该资源'
                console.log('请求错误,未找到该资源')
                break;
            case 405:
                error.message = '请求方法未允许'
                console.log('请求方法未允许')
                break;
            case 408:
                error.message = '请求超时'
                console.log('请求超时')
                break;
            case 500:
                error.message = '服务器端出错'
                console.log('服务器端出错')
                break;
            case 501:
                error.message = '网络未实现'
                console.log('网络未实现')
                break;
            case 502:
                error.message = '网络错误'
                console.log('网络错误')
                break;
            case 503:
                error.message = '服务不可用'
                console.log('服务不可用')
                break;
            case 504:
                error.message = '网络超时'
                console.log('网络超时')
                break;
            case 505:
                error.message = 'http版本不支持该请求'
                console.log('http版本不支持该请求')
                break;
            default:
                error.message = `连接错误${error.response.status}`
                console.log(`连接错误${error.response.status}`)
        }
    } else {
        error.message = '';
    }
    // if (error && error.response && error.response.status) {
       
    // }
    return Promise.reject(error.response);
});
export default https;
